import { Image } from 'component/Image'
import { Space } from 'component/Space'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { controller } from 'store/controller'
import { store } from 'store/store'
import css from './DefaultSelfie.module.scss'

type Props = {
  src: string
}

export const DefaultSelfie = observer(({ src }: Props) => {
  const onClick = useLatestCallback(async () => {
    store.profile.common.selfies[0].clear()
    store.profile.common.selfies[1].clear()
    await controller.ensureUser()
    await store.profile.common.selfies[0].setAsset(src)
  })

  return <Space className={css.selfie} round onClick={onClick}>
    <Image src={src} />
  </Space>
})
